import {
    GET_DICTIONARY_REPORT_COURIER_PERIOD_ERROR,
    GET_DICTIONARY_REPORT_COURIER_PERIOD_REQUEST,
    GET_DICTIONARY_REPORT_COURIER_PERIOD_SUCCESS
} from "../constants/dictionaryReportCourierPeriod";
import {IDictionary} from "../../models/Dictionary";
import {IActionDictionaryReportCourierPeriod} from "../actions/dictionaryReportCourierPeriod";


export interface IDictionaryReportCourierPeriodState {
    loading: boolean
    error: string
    data: IDictionary[]
}

const initialState: IDictionaryReportCourierPeriodState = {
    data: [],
    loading: false,
    error: ''
};

export default function dictionaryReportCourierPeriod(state = initialState, action: IActionDictionaryReportCourierPeriod): IDictionaryReportCourierPeriodState {
    switch (action.type) {
        case GET_DICTIONARY_REPORT_COURIER_PERIOD_REQUEST:
            return {
                data: [],
                loading: true,
                error: ''
            };
        case GET_DICTIONARY_REPORT_COURIER_PERIOD_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: ''
            };
        case GET_DICTIONARY_REPORT_COURIER_PERIOD_ERROR:
            return {
                data: [],
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}
